<template>
  <div>
    <div class="management-sidebar" :class="{ closed: !sidebarIsOpen }">
      <div style="margin: 0 auto">
        <WeezieLogo
          :sidebarIsOpen="sidebarIsOpen"
          :class="hubButtonClass"
          @click="$router.push({ name: 'hub' })"
        />
        <md-tooltip
          class="return-to-tooltip"
          :class="{ closed: !sidebarIsOpen }"
          :md-direction="sidebarIsOpen ? 'bottom' : 'right'"
        >
          {{ $t("BackToHub") }}
        </md-tooltip>
      </div>

      <div class="management-sidebar-scroll">
        <div
          v-for="menuItem in menu"
          :key="menuItem.name"
          v-if="!menuItem.disabled"
        >
          <menu-item
            v-if="sidebarIsOpen"
            :item="menuItem"
            :selected="selectedMenu"
            @toggle="toggleMenu($event, menuItem.submenu)"
          >
            <template v-slot:icon>
              <component
                :is="menuItem.icon"
                width="18px"
                :style="{ fill: activeTab(menuItem) ? 'white' : 'black' }"
              />
            </template>

            <template v-slot:subMenu>
              <transition-group name="fade" mode="out-in">
                <div
                  v-show="activeTab(menuItem)"
                  v-for="submenuItem in menuItem.submenu"
                  :key="submenuItem.name"
                >
                  <sub-menu-item
                    v-if="(isSuperAdmin || !submenuItem.dev) && !submenuItem.disabled"
                    :item="submenuItem"
                    :selected="selectedSubMenu"
                    :disabled="submenuItem.disabled"
                    @toggle="toggleSubMenu"
                  />
                </div>
              </transition-group>
            </template>
          </menu-item>

          <v-tooltip right v-if="!sidebarIsOpen">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                class="buttonContainer"
                :class="{ selected: activeTab(menuItem) }"
                @click="toggleSidebar(menuItem, menuItem.submenu)"
                v-bind="attrs"
                v-on="on"
              >
                <template>
                  <component
                    :is="menuItem.icon"
                    width="18px"
                    :style="{ fill: activeTab(menuItem) ? 'white' : 'black' }"
                  />
                </template>
              </v-btn>
            </template>

            <span>{{ menuItem.name }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import WeezieLogo from "@/assets/logos/WeezieLogo.vue";
import MenuItem from "./SidebarMenuItem";
import SubMenuItem from "./SidebarSubmenuItem";
import SidebarButton from "../../Home/SideBar/SidebarButton.vue";

export default {
  name: "sidebar",

  components: {
    WeezieLogo,
    MenuItem,
    SubMenuItem,
    SidebarButton
  },

  mixins: [checkPermissionsMixin],

  props: ["sidebarIsOpen", "menu"],

  data() {
    return {
      selectedMenu: null,
      selectedSubMenu: null
    };
  },

  computed: {
    hubButtonClass() {
      return this.sidebarIsOpen
        ? "management-fibercloud-svg-logo"
        : "hub-button-reduced";
    }
  },

  watch: {
    $route(to) {
      this.setSelectedMenuOption(to);
    }
  },

  mounted() {
    this.setSelectedMenuOption(this.$route);
  },

  methods: {
    toggleMenu(menu, subMenu) {
      if (this.selectedMenu === null && this.selectedSubMenu !== subMenu[0]) {
        this.selectedMenu = menu;
      } else if (this.selectedMenu !== menu) {
        this.selectedMenu = menu;
        if (subMenu.length > 0) {
          this.selectedSubMenu = subMenu.find(item => !item.disabled);
          if (
            this.selectedSubMenu &&
            this.$route.name !== this.selectedSubMenu.route
          ) {
            this.$router.push({ name: this.selectedSubMenu.route });
          }
        }
      }
    },

    toggleSubMenu(item) {
      if (item.route !== this.$route.name) {
        this.selectedSubMenu = {
          dev: item.dev,
          disabled: item.disabled,
          name: item.name,
          route: item.route
        };
        this.$router.push({ name: item.route });
      }
    },

    setSelectedMenuOption(route) {
      for (const menu of this.menu) {
        let submenu = menu.submenu.find(
          submenu => submenu.route === route.matched[route.matched.length - 1].name
        );
        if (submenu) {
          this.selectedMenu = menu;
          this.selectedSubMenu = submenu;
          break;
        }
      }
    },

    toggleSidebar(menuItem, submenu) {
      this.$emit("toggle-sidebar");
      this.toggleMenu(menuItem, submenu);
    },

    activeTab(item) {
      if (this.selectedMenu && item) {
        return this.selectedMenu.name === item.name;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.return-to-tooltip {
  color: var(--secondary-lighter);
  z-index: 200;
}
.return-to-tooltip.closed {
  background-color: var(--v-secondary-darken1);
}
.management-sidebar.closed {
  width: 67px;
  align-items: flex-start;
}
.buttonContainer {
  min-width: 0;
  width: 67px;
  height: 44px;
  cursor: pointer;
  margin: 0 auto;
  background-color: transparent !important;
}
.buttonContainer.selected {
  background-color: var(--app-primary-base) !important;
}
.hub-button-reduced {
  width: 40px;
  margin-top: 15px;
  cursor: pointer;
  margin-bottom: 55px;
}
.management-fibercloud-svg-logo {
  height: 50px;
  margin-top: 50px;
  width: 40%;
  cursor: pointer;
}

.management-sidebar .weezie-logo-management.management-fibercloud-svg-logo {
  width: 80% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/Sidebar/Sidebar.vue